/* eslint-disable max-classes-per-file */
import { DateUtils } from "~app/common/utils/date-utils";

const DateStringFormat = "YYYY-MM-DD HH:mm:ss";

export interface ISchemalaggningListDetail {
    jobbNamn: string;
    senastSlut: Date;
    senastVaraktighet: number;
    senastResultat: string;
    senastStatuskod: string;
    nastaStart: Date;
    status: string;
}

export interface ISchemalaggningDetail {
    start: Date;
    slut: Date;
    varaktighet: number;
    resultat: string;
    statuskod: string;
}

export class SchemalaggningDetailViewModel {

    constructor(private readonly model: ISchemalaggningDetail) {
    }

    get start() {
        if (!this.model.start) {
            return "";
        }

        return DateUtils.formatDateString(this.model.start, DateStringFormat);
    }

    get slut() {
        if (!this.model.slut) {
            return "";
        }

        return DateUtils.formatDateString(this.model.slut, DateStringFormat);
    }

    get varaktighet() {
        return this.model.varaktighet;
    }

    get resultat() {
        return this.model.resultat;
    }

    get statuskod() {
        return this.model.statuskod;
    }
}

export class SchemalaggningViewModel {
    constructor(private readonly model: ISchemalaggningListDetail) {
    }

    get jobbNamn() {
        return this.model.jobbNamn;
    }

    get senastVaraktighet() {
        return this.model.senastVaraktighet;
    }

    get senastResultat() {
        return this.model.senastResultat;
    }

    get senastSlut() {
        if (!this.model.senastSlut) {
            return "";
        }

        return DateUtils.formatDateString(this.model.senastSlut, DateStringFormat);
    }

    get senastStatuskod() {
        return this.model.senastStatuskod;
    }

    get nastaStart() {
        return this.model.nastaStart;
    }

    get status() {
        return this.model.status;
    }
}

export class LastEntriesForJobbtypViewModel   {

    jobbtyp: string;
    jobbId: number;
    status: string;
    start: string;
    slut: string;
    meddelande: string;

    constructor(private readonly model: LastEntriesForJobbtypViewModel) {
        this.jobbtyp = model.jobbtyp;
        this.jobbId = model.jobbId;
        this.status = model.status;
        this.start = DateUtils.formatDateString(this.model.start, DateStringFormat);
        this.slut = DateUtils.formatDateString(this.model.slut, DateStringFormat);
        this.meddelande = model.meddelande;
    }
}
